import * as React from "react";
import { IAuthProviderProps } from "../models/IAuthProviderProps";
const AuthContext: any = React.createContext({});


export const AuthProvider: React.FC<IAuthProviderProps> = ({ children }) => {
  const [auth, setAuth] = React.useState<any>({});

  const providerValue = React.useMemo(
    () => ({ auth, setAuth }),
    [auth, setAuth]
  );

  return (
    <AuthContext.Provider value={providerValue}>
      {children}
    </AuthContext.Provider>
  );
};

export default AuthContext;
